// extracted by mini-css-extract-plugin
export default {"navbarHeight":"60px","tip-icon-container":"styles_tip-icon-container__k8tTr","tipIconContainer":"styles_tip-icon-container__k8tTr"};